import React from 'react'
import './pdcaplanometarow.scss'

export default ({ itens = [] }) => {
  const itensValidos = itens.filter(item => item && item.value !== null && item.value !== undefined && item.value !== '')

  if (!itensValidos.length) {
    return null
  }

  return (
    <div className='pdca-plano-meta-row'>
      {itensValidos.map((item, index) => (
        <div className='pdca-plano-meta-row-item' key={`${item.label}-${index}`}>
          <span className='pdca-plano-meta-row-label'>{item.label}:</span>
          <span className='pdca-plano-meta-row-value'>{item.value}</span>
        </div>
      ))}
    </div>
  )
}